export default {"src":"/_next/static/media/Solution4.da0d21f9.svg","height":49,"width":49};